import React from 'react';
import { Dropdown } from 'react-bootstrap';

interface DropdownItemProps {
  eventKey: string;
  label: string;
  onSelect: (eventKey: string) => void;
}

const DropdownItem: React.FC<DropdownItemProps> = ({
  eventKey,
  label,
  onSelect,
}) => (
  <Dropdown.Item eventKey={eventKey} onSelect={() => onSelect(eventKey)}>
    {label}
  </Dropdown.Item>
);

export default DropdownItem;
